import CheckAffiliateBasedOnLEAndCountry from '../CheckAffiliateBasedOnLEAndCountry';

export const CheckEUAffiliate = (country: string = ''): boolean => {
    const countryList: string[] = ['ESP'];

    return country !== '' ? countryList.includes(country) : CheckAffiliateBasedOnLEAndCountry(countryList);
};